import { getChainCommissions } from 'app/services/configurations';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

export default {
  useGetSelectedPharmacyInfo() {
    const { enqueueSnackbar } = useSnackbar();
    const { user } = useSelector((state) => state.auth);
    const { selectedPharmacy } = useSelector((state) => state.pharmacySelector);
    const [chainCommissions, setChainCommissions] = useState(null);

    useEffect(() => {
      (async () => {
        try {
          if (!user._id || !selectedPharmacy) return;
          const commissions = await getChainCommissions(selectedPharmacy.chain);
          setChainCommissions(commissions);
        } catch (error) {
          enqueueSnackbar(error.message, { variant: 'error' });
        }
      })();
    }, [selectedPharmacy, enqueueSnackbar, user]);

    return {
      chainCommissions,
      ...(selectedPharmacy && {
        isProActivated: selectedPharmacy.chain?.pro?.enabled && selectedPharmacy.chain.pro.billing,
        chainId: selectedPharmacy.chain_id,
        primaryUser: selectedPharmacy.chain?.primaryUser?.email,
        selectedPharmacyId: selectedPharmacy._id,
        activationJourneyDisabled:
          selectedPharmacy.chain?.feature_flags?.pro_activation_journey === false,
      }),
    };
  },
};
